'use client'

import { useState } from 'react'

function readCsrfCookie(): string | null {
  const m = document.cookie.match(/(?:^|; )__Host-buyer\.csrf=([^;]+)/)
  return m ? decodeURIComponent(m[1]) : null
}

export function SignOutClient() {
  const [busy, setBusy] = useState(false)

  async function signOut() {
    if (busy) return
    setBusy(true)
    const csrf = readCsrfCookie()
    try {
      await fetch('/api/buyer/logout', {
        method: 'POST',
        headers: csrf ? { 'X-CSRF-Token': csrf } : undefined,
      })
    } catch {
      // ignore — we still reload, the cookie is cleared by the server
      // if logout succeeded; otherwise client-side state diverges only
      // briefly and the next protected hit will re-prompt sign-in.
    }
    window.location.assign('/')
  }

  return (
    <button
      type="button"
      onClick={signOut}
      disabled={busy}
      className="px-3 py-1.5 text-xs font-semibold text-text-2 border border-[rgba(255,255,255,0.07)] rounded hover:text-text-1 hover:border-cyan/20 disabled:opacity-40"
    >
      {busy ? 'Signing out…' : 'Sign out'}
    </button>
  )
}
